export default __webpack_public_path__ + "static/media/hero-screen-2.62b0accc.png";